import {ValueObject} from '@s-ui/domain'

export class UpdateDataUserRequest extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.hidePhone
   * @param {String} data.lastName
   * @param {String} data.name
   * @param {String} data.phone
   * @param {String} data.zipCode
   **/
}
